module.exports = __webpack_public_path__ + "media/packs/static/fonts/circular-std/medium-06dce1b52a24a6dfe3a263efae4acc9f.woff2";